module.exports = __webpack_public_path__ + "img/20190829151117840.61194025.jpg";